var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('h1',{staticClass:"mb-4"},[_vm._v("Stocks")]),_c('div',{staticClass:"row"},_vm._l((_vm.stocks),function(stock){return _c('app-stock',{key:stock.id,attrs:{"stock":stock}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }